/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pulse': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.73 3c.9 0 1.7.58 1.98 1.44l10.56 31.82 4.3-12.92a2.1 2.1 0 0 1 1.98-1.44h8.36a2.1 2.1 0 0 1 0 4.2h-6.86l-5.8 17.46a2.1 2.1 0 0 1-3.96 0L17.73 11.74l-4.3 12.92a2.1 2.1 0 0 1-1.98 1.44H3.1a2.1 2.1 0 0 1 0-4.2h6.86l5.8-17.46A2.1 2.1 0 0 1 17.72 3z"/>'
  }
})
